export class AddIngredeintItemModel {
    public name: string;
    public description: string;
    public code: string;
    public unitOfMeasurementId: string;
    public companyId: string;
    public supplierName: string;
    public date: string | Date;
}
